import { styled as muiStyled } from "@mui/material/styles";

/**
 * The styled() utility from MUI for creating styled components with theme access.
 *
 * This is the recommended way to apply custom styles in the project.
 * It provides full access to the theme and supports the sx prop pattern.
 *
 * @example
 * const StyledButton = styled(Button)(({ theme }) => ({
 *   backgroundColor: theme.palette.primary.main,
 *   padding: theme.spacing(2),
 * }));
 */
export const styled = muiStyled;
